<div class="print-page">
  @if (response) {
    @for (component of components; track $index) {
      @if (!$first) {
        <hr
          class="print-section-divider hr-dynamic-theme"
          [class.print-section-divider--before-thank-you]="
            component.componentType === 'THANKYOU_INFORMATION'
          "
        />
      }
      @switch (component.componentType) {
        @case ("PASSWORD") {
          <section class="print-section print-section--password print-content-section">
            <h1
              class="print-section-title"
              [innerHTML]="response.surveyTitle | safeHtml"
            ></h1>
            <h2>Password</h2>
            <div class="print-answer-line"></div>
          </section>
        }
        @case ("INITIAL_INFORMATION") {
          <section class="print-section print-section--information print-content-section">
            <h1
              class="print-section-title"
              [innerHTML]="response.surveyTitle | safeHtml"
            ></h1>
            @for (child of getChildren(component); track $index) {
              @switch (child.componentType) {
                @case ("INFORMATION") {
                  <div
                    class="rich-text-content"
                    [innerHTML]="getMessage(child) | safeHtml"
                  ></div>
                }
                @case ("HIDDEN_INFORMATION") {
                  <div class="print-choice-block">
                    @switch (getHiddenIdentityValue(child)) {
                      @case (true) {
                        <p>{{ "welcome.hiddenidentity.hidden.title" | translate }}</p>
                        <p>{{ "welcome.hiddenidentity.information" | translate }}</p>
                      }
                      @case (null) {
                        <div class="print-checkbox-row">
                          <span class="print-checkbox" aria-hidden="true"></span>
                          <span>{{ "welcome.hiddenidentity.optional.title" | translate }}</span>
                        </div>
                        <p>{{ "welcome.hiddenidentity.information" | translate }}</p>
                      }
                    }
                  </div>
                }
                @case ("COLLECT_EMAIL") {
                  <div class="print-field-row">
                    <span>{{ "information.collectemail.text" | translate }}</span>
                    <span class="print-answer-line"></span>
                  </div>
                }
              }
            }
          </section>
        }
        @case ("GDPR_CONSENT") {
          @if (isGdprComponent(component)) {
            <section class="print-section print-section--gdpr print-content-section">
              <h1
                class="print-section-title"
                [innerHTML]="response.surveyTitle | safeHtml"
              ></h1>
              <h2>{{ "gdpr.statement.infoaboutdataprocessing" | translate }}</h2>
              @if (component.statement.welcomeMessage) {
                <div
                  class="rich-text-content"
                  [innerHTML]="component.statement.welcomeMessage | safeHtml"
                ></div>
              }
              <div
                class="rich-text-content"
                [innerHTML]="component.statement.purposeStatement | safeHtml"
              ></div>

              <div class="print-gdpr-grid">
                <div>
                  <h3>
                    {{ "gdpr.statement.field.controllername.respondentname" | translate }}
                  </h3>
                  <div
                    [innerHTML]="component.statement.controllerName | newlineToBr | safeHtml"
                  ></div>
                  <div
                    [innerHTML]="component.statement.controllerDetails | newlineToBr | safeHtml"
                  ></div>
                </div>
                @if (component.statement.representativeName) {
                  <div>
                    <h3>
                      {{
                        "gdpr.statement.field.representativename.respondentname"
                          | translate
                      }}
                    </h3>
                    <div
                      [innerHTML]="
                        component.statement.representativeName | newlineToBr | safeHtml
                      "
                    ></div>
                  </div>
                }
              </div>

              @for (field of getGdprFields(component.statement); track field.label) {
                <div class="print-gdpr-field">
                  <h3>{{ field.label | translate }}</h3>
                  <div [innerHTML]="field.value | newlineToBr | safeHtml"></div>
                </div>
              }

              <div class="print-checkbox-row print-gdpr-consent">
                <span class="print-checkbox" aria-hidden="true"></span>
                <span>{{ "gdpr.statement.processingagree" | translate }}</span>
              </div>
            </section>
          }
        }
        @case ("QUESTIONS") {
          @if (isQuestionComponent(component)) {
            <section class="print-section print-section--questions">
              <app-survey-form
                [answers]="answers"
                [responseId]="response.responseId"
                [currentState]="response.stateId"
                [questions]="component.questions"
                [displayBackButton]="response.enableBackNavigation"
                [showNavigation]="false"
                [surveyTitle]="response.surveyTitle"
              >
              </app-survey-form>
            </section>
          }
        }
        @case ("THANKYOU_INFORMATION") {
          <section class="print-section print-section--thank-you print-content-section">
            <h1
              class="print-section-title"
              [innerHTML]="response.surveyTitle | safeHtml"
            ></h1>
            @for (child of getChildren(component); track $index) {
              @if (child.componentType === "INFORMATION") {
                @if (getMessage(child)) {
                  <div
                    class="rich-text-content"
                    [innerHTML]="getMessage(child) | safeHtml"
                  ></div>
                } @else {
                  <div>{{ "thankyou.defaulttext" | translate }}</div>
                }
              }
            }
          </section>
        }
        @case ("INFORMATION") {
          <section class="print-section print-section--information print-content-section">
            <h1
              class="print-section-title"
              [innerHTML]="response.surveyTitle | safeHtml"
            ></h1>
            <div
              class="rich-text-content"
              [innerHTML]="getMessage(component) | safeHtml"
            ></div>
          </section>
        }
      }
    }
  }
</div>
